<ion-header
  class="ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService.platformEnum.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label data-cy="homepage-title-help-text">
      {{ 'i18n.helpTooltips.touch.homepage.title.help' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content
  [ngClass]="
    platformService?.platformType === platformService.platformEnum.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <ion-grid>
    <!-- HOME PAGE -->
    <ng-container *ngIf="(this.panAppState?.pageTitle$ | async) === 'Home'">
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="homepage-title-text">
              {{ 'i18n.helpTooltips.touch.homepage.title.help' | translate }}
            </div>
            <p class="main-help-text" data-cy="homepage-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
                >{{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="homepage-title-tiles-text"
          >
            {{ 'i18n.helpTooltips.touch.homepage.title.tiles' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="homepage-tip-tiles-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.homepage.tip.tiles' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="homepage-title-shopping-cart-text"
          >
            {{
              'i18n.helpTooltips.touch.homepage.title.shoppingCart' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="homepage-tip-shopping-cart-text"
          >
            <span data-cy="homepage-tip-shopping-cart-text">{{
              'i18n.helpTooltips.touch.homepage.tip.shoppingCart' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="homepage-title-have-feedback-text"
          >
            {{
              'i18n.helpTooltips.touch.homepage.title.haveFeedback' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="homepage-tip-have-feedback-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.homepage.tip.haveFeedback' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="homepage-title-additional-tools-text"
          >
            {{
              'i18n.helpTooltips.touch.homepage.title.additionalTools'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="homepage-tip-additional-tools-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.homepage.tip.additionalTools' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="homepage-title-search-bar-text"
          >
            {{ 'i18n.helpTooltips.touch.homepage.title.searchBar' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="homepage-tip-search-bar-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.homepage.tip.searchBar' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- SEARCH PAGE -->
    <ng-container
      *ngIf="(this.panAppState?.pageTitle$ | async) === 'Shop Products'"
    >
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="search-title-text">
              {{
                'i18n.helpTooltips.desktop.search.title.searchPageTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="search-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
              >
                {{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-product-status-indicators-text"
          >
            {{
              'i18n.helpTooltips.touch.search.title.productStatusIndicators'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-product-status-indicators-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.productStatusIndicators'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-filters-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.filters' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-filters-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.filters' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-cartridges-text"
          >
            {{
              'i18n.helpTooltips.touch.search.title.searchCartridges'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-cartridges-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.searchCartridges' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-quick-view-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.quickView' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-quick-view-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.quickView' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-navigate-to-pdp-text"
          >
            {{
              'i18n.helpTooltips.touch.search.title.navigatingToProductDetailPage'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-navigate-to-pdp-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.navigatingToProductDetailPage'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-product-drawer-text"
          >
            {{
              'i18n.helpTooltips.touch.search.title.productDrawer' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-product-drawer-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.productDrawer' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-add-to-order-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.addToOrder' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-add-to-order-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.addToOrder' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-add-to-list-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.addToList' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-add-to-list-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.addToList' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-feedback-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.feedback' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-feedback-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.feedback' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-back-to-list-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.backToList' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-back-to-list-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.backToList' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="search-title-search-bar-text"
          >
            {{ 'i18n.helpTooltips.touch.search.title.searchBar' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="search-tip-search-bar-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.search.tip.searchBar' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- LISTS PAGE -->
    <ng-container *ngIf="(this.panAppState?.pageTitle$ | async) === 'My Lists'">
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="list-title-text">
              {{
                'i18n.helpTooltips.touch.listManagement.title.listsTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="list-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
                >{{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-edit-list-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.editLists'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-edit-list-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.editLists'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-move-products-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.movingProductsInGroups'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-move-products-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.movingProductsInGroups'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-move-groups-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.movingGroups'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-move-groups-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.movingGroups'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-line-numbers-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.lineNumbers'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-line-numbers-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.lineNumbers'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-add-vendor-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.addingAVendor'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-add-vendor-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.addingAVendor'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="list-title-add-non-usf-text"
          >
            {{
              'i18n.helpTooltips.touch.listManagement.title.addingANonUsfProduct'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="list-tip-add-non-usf-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.listManagement.tip.addingANonUsfProduct'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- ORDER PAGE -->
    <ng-container
      *ngIf="(this.panAppState?.pageTitle$ | async) === 'Current Order'"
    >
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="order-title-text">
              {{
                'i18n.helpTooltips.touch.ordering.title.orderingTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="order-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
              >
                {{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-search-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.searchWithinList'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-search-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.searchWithinList'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-sort-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.sortFilter' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-title-sort-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.sortFilter' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-add-order-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.addToOrder' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-add-order-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.addToOrder' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-status-indicators-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.productStatusIndicators'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-status-indicators-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.productStatusIndicators'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-quickview-text"
          >
            {{ 'i18n.helpTooltips.touch.ordering.title.quickView' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-quickview-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.quickView' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-navigate-to-pdp-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.navigatingToProductDetailPage'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-navigate-to-pdp-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.navigatingToProductDetailPage'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="order-title-product-drawer-text"
          >
            {{
              'i18n.helpTooltips.touch.ordering.title.productDrawer' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="order-tip-product-drawer-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.ordering.tip.productDrawer' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- PRODUCTS PAGE/INVENTORY WORKSHEET PAGE -->
    <ng-container
      *ngIf="
        (this.panAppState?.pageTitle$ | async) === 'Product Detail' ||
        (this.panAppState?.pageTitle$ | async) === 'Inventory'
      "
    >
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="pdp-title-text">
              {{
                'i18n.helpTooltips.touch.productDetailPage.title.productDetailTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="pdp-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
              >
                {{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-videos-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.videos'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-videos-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.videos'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-inventory-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.inventory'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-inventory-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.inventory'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-price-per-portion-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.pricePerPortion'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-price-per-portion-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.pricePerPortion'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-features-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.featuresBenefits'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-features-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.featuresBenefits'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-also-bought-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.customersAlsoBought'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-also-bought-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.customersAlsoBought'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-qa-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.qA' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-qa-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.qA' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-ratings-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.ratingsReviews'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-ratings-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.ratingsReviews'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="pdp-title-product-status-text"
          >
            {{
              'i18n.helpTooltips.touch.productDetailPage.title.productStatusIndicators'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="pdp-tip-product-status-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.productDetailPage.tip.productStatusIndicators'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- MY ORDERS PAGE -->
    <ng-container
      *ngIf="(this.panAppState?.pageTitle$ | async) === 'My Orders'"
    >
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="myorders-title-text">
              {{
                'i18n.helpTooltips.touch.myOrders.title.myOrdersTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="myorders-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
                >{{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-dashboard-text"
          >
            {{ 'i18n.helpTooltips.touch.myOrders.title.dashboard' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-dashboard-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.dashboard' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-filter-text"
          >
            {{ 'i18n.helpTooltips.touch.myOrders.title.filter' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-filter-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.filter' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-dates-text"
          >
            {{ 'i18n.helpTooltips.touch.myOrders.title.dates' | translate }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-dates-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.dates' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-labels-text"
          >
            {{
              'i18n.helpTooltips.touch.myOrders.title.orderLabels' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-labels-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.orderLabels' | translate
              }}
              <br />
              <br />
              {{
                'i18n.helpTooltips.touch.myOrders.tip.orderLabels2' | translate
              }}
              <br />
              <br />
              {{
                'i18n.helpTooltips.touch.myOrders.tip.orderLabels3' | translate
              }}
              <br />
              <br />
              {{
                'i18n.helpTooltips.touch.myOrders.tip.orderLabels4' | translate
              }}
            </span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-delivery-tracking-text"
          >
            {{
              'i18n.helpTooltips.touch.myOrders.title.deliveryTracking'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-delivery-tracking-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.deliveryTracking'
                  | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="myorders-title-caching-text"
          >
            {{
              'i18n.helpTooltips.touch.myOrders.title.cachingIssues' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="myorders-tip-caching-text"
          >
            <span>
              {{
                'i18n.helpTooltips.touch.myOrders.tip.cachingIssues' | translate
              }}</span
            >
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- PROFILE PAGE -->
    <ng-container *ngIf="(this.panAppState?.pageTitle$ | async) === 'Profile'">
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="profile-title-text">
              {{
                'i18n.helpTooltips.touch.profile.title.profileTitle' | translate
              }}
            </div>
            <p class="main-help-text" data-cy="profile-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
                >{{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="profile-title-preference-center-text"
          >
            {{
              'i18n.helpTooltips.touch.profile.title.preferenceCenter'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="profile-tip-preference-center-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.profile.tip.preferenceCenter' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="profile-title-caching-text"
          >
            {{
              'i18n.helpTooltips.touch.profile.title.cachingIssues' | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="profile-tip-caching-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.profile.tip.cachingIssues' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>

    <!-- NOTIFICATIONS PAGE -->
    <ng-container
      *ngIf="(this.panAppState?.pageTitle$ | async) === 'Notifications'"
    >
      <section>
        <ion-row>
          <ion-col>
            <div class="page-name" data-cy="notifications-title-text">
              {{
                'i18n.helpTooltips.touch.notifications.title.notificationsTitle'
                  | translate
              }}
            </div>
            <p class="main-help-text" data-cy="notifications-help-text">
              {{
                'i18n.helpTooltips.touch.homepage.tip.needMoreHelp' | translate
              }}
              <a
                href="https://www.usfoods.com/our-services/moxe-help-center.html"
                class="help-center-link"
                target="_BLANK"
                data-cy="modal-help-center-link"
                >{{
                  'i18n.helpTooltips.touch.homepage.title.helpCenter'
                    | translate
                }}</a
              >.
            </p>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="notifications-title-alerts-text"
          >
            {{
              'i18n.helpTooltips.touch.notifications.title.alertsRecommendations'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="notifications-tip-alerts-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.notifications.tip.alertsRecommendations'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="notifications-title-preference-center-text"
          >
            {{
              'i18n.helpTooltips.touch.notifications.title.preferenceCenter'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="notifications-tip-preference-center-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.notifications.tip.preferenceCenter'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="notifications-title-product-status-text"
          >
            {{
              'i18n.helpTooltips.touch.notifications.title.productStatusIndicators'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="notifications-tip-product-status-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.notifications.tip.productStatusIndicators'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="notifications-title-quickview-text"
          >
            {{
              'i18n.helpTooltips.touch.notifications.title.quickView'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="notifications-tip-quickview-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.notifications.tip.quickView' | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
        <ion-row>
          <ion-col
            size="6"
            size-lg="2.5"
            size-md="2.5"
            size-xs="5"
            data-cy="notifications-title-product-drawer-text"
          >
            {{
              'i18n.helpTooltips.touch.notifications.title.productDrawer'
                | translate
            }}
          </ion-col>
          <ion-col
            size="6"
            size-lg="9.5"
            size-md="9.5"
            size-xs="7"
            data-cy="notifications-tip-product-drawer-text"
          >
            <span>{{
              'i18n.helpTooltips.touch.notifications.tip.productDrawer'
                | translate
            }}</span>
          </ion-col>
        </ion-row>
        <hr />
      </section>
    </ng-container>
  </ion-grid>
</ion-content>
